import React, {useLayoutEffect} from "react";
import {Icon} from '@dspworkplace/ui';
import styled from 'styled-components';
import useScript from "../hooks/useScript";

const ReleaseBadge = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;

    #HW_badge_cont {
        height: 100%;
        display: block;

        #HW_badge {
                margin-left: 18px;
                font-size: 0;
                width: 8px !important;
                height: 8px !important;
                min-width: unset !important;
                border-radius: 50% !important;
                top: 0px !important;
                left: 8px !important;

            &:empty {
                opacity: 0;
            }
        }
    }
`;

const NoFillIcon = styled.span`
    display: inline-flex;
    align-items: center;
    svg path, svg circle, svg rect {
        fill: none !important;
    }
`;

const useReleaseNote = () => {
    const account = process.env.REACT_APP_HEADWAY_ACCOUNT;
    if (!account) {
        return (
            <span className={'release-note'} style={{position: 'relative', display: 'inline-flex', alignItems: 'center'}}
                  id={'release-button'}>
                <NoFillIcon>
                    <Icon.NotificationV2 size='22px'/>
                </NoFillIcon>
                <ReleaseBadge className={'release-note-badge'}/>
            </span>
        );
    }
    return <ReleaseNoteComponent account={account}/>

}

const ReleaseNoteComponent = ({account}) => {
    const releaseNoteScriptStatus = useScript("https://cdn.headwayapp.co/widget.js");

    useLayoutEffect(() => {
        if (releaseNoteScriptStatus === 'ready') {
            const HW_config = {
                selector: '.release-note-badge', // CSS selector where to inject the badge
                account: account
            }
            window.Headway.init(HW_config);

        }
        const observer = new MutationObserver(() => {
            const hwFrame = document.getElementById('HW_frame_cont');
            if (hwFrame && hwFrame.style.top !== '56px') {
                hwFrame.style.top = '56px';
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style']
        });

        return () => observer.disconnect();

    }, [releaseNoteScriptStatus, account])

    return <span className={'release-note'} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
        id={'release-button'}>
        <NoFillIcon>
            <Icon.NotificationV2 size='22px' />
        </NoFillIcon>
        <ReleaseBadge className={'release-note-badge'} />
    </span>;
}

export {useReleaseNote}